import React from 'react'
import "./styles.css"

const Brackground = () => {
  return (
    <>
        <div className='feixe1'></div>
        <div className='feixe2'></div>
    </>
  )
}

export default Brackground